<template>
  <div>
    <v-card elevation="0" class="text-center text-md-right">
      <v-row v-if="$vuetify.breakpoint.smAndDown">
        <v-col cols="12">
          <v-img max-height="150px" contain src="/static/images/doodles-dsfr/primary/SittingChef.png"></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="7">
          <v-card-title>
            <v-spacer></v-spacer>
            <div>
              <div class="text-caption text-uppercase font-weight-bold primary--text text-center text-md-right mb-2">
                Groupe Labsoft · Lauréat PNNS 2020 · EcoVadis Gold
              </div>
              <h1 class="font-weight-black text-h4 mt-0 mt-sm-2 text-center text-md-right">
                Fluidifiez, pilotez, innovez
                <br v-if="$vuetify.breakpoint.mdAndUp" />
                la gestion en restauration collective.
              </h1>
              <p class="text-body-2 mt-3 text-center text-md-right grey--text text--darken-2">
                Labricot dans ma cantine est la plateforme de services outillés qui connecte l'école, la cantine et la
                cuisine centrale — pour réduire le gaspillage, engager les convives et démontrer votre conformité
                EGAlim, en 3 clics par service.
              </p>
              <div v-if="!loggedUser" class="d-flex flex-wrap justify-center justify-md-end mt-4" style="gap: 8px">
                <v-btn href="/creer-mon-compte" color="primary" depressed>Créer mon compte gratuitement</v-btn>
                <v-btn href="/s-identifier" color="primary" outlined>M'identifier</v-btn>
              </div>
              <div class="d-flex flex-wrap justify-center justify-md-end mt-4" style="gap: 8px">
                <v-chip small color="primary" outlined>
                  <v-icon left x-small>$award-fill</v-icon>
                  Lauréat PNNS 2020
                </v-chip>
                <v-chip small color="green" outlined text-color="green darken-2">EGAlim</v-chip>
                <v-chip small color="orange darken-1" outlined text-color="orange darken-2">Anti-gaspillage</v-chip>
                <v-chip small outlined>🇫🇷 Souverain</v-chip>
              </div>
            </div>
            <v-spacer v-if="$vuetify.breakpoint.smAndDown"></v-spacer>
          </v-card-title>
        </v-col>
        <v-col cols="3" class="d-flex flex-column align-end" v-if="$vuetify.breakpoint.mdAndUp">
          <div class="d-flex flex-column" style="gap: 8px; width: 100%; margin-bottom: 12px">
            <v-card outlined class="pa-2 text-center" style="border-radius: 12px">
              <v-img src="/static/images/etincelle_gouv.png" contain max-height="36px" class="mx-auto"></v-img>
              <div class="text-caption grey--text">Lauréat 2024</div>
            </v-card>
            <v-card outlined class="pa-2 text-center" style="border-radius: 12px">
              <span class="text-h6 font-weight-black green--text text--darken-1">−12%</span>
              <div class="text-caption grey--text">gaspillage constaté</div>
            </v-card>
            <v-card outlined class="pa-2 text-center" style="border-radius: 12px">
              <span class="text-h6 font-weight-black orange--text text--darken-1">24 ans</span>
              <div class="text-caption grey--text">d'expérience terrain</div>
            </v-card>
          </div>
          <v-img max-height="140px" contain src="/static/images/doodles-dsfr/primary/SittingChef.png"></v-img>
        </v-col>
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PresentationBlock",
  computed: {
    loggedUser() {
      return this.$store.state.loggedUser
    },
  },
}
</script>
